import {listener} from "../../../../../modules/vegas/js/util";
import Catalog from "./catalog";

listener('click', '.catalog-sort [data-sort]', function (el, e) {
	let input = document.getElementById('catalog-filter-form')?.querySelector('[name="sort"]');

	if (input) {
		input.value = el.dataset.sort;

		let container = el.closest('.catalog-sort');
		let titleElement = container.querySelector('.catalog-sort--link');
		titleElement.innerText = String(el.innerText).trim();

		[...container.querySelectorAll('[data-sort]')].forEach(el => el.classList.remove('active'));
		el.classList.add('active');

		new Catalog().load();
	}
});

listener('click', '.catalog-sort--sidebar [data-sort]', (el, e) => {
	let input = document.getElementById('catalog-filter-form')?.querySelector('[name="sort"]');

	if (input) {
		input.value = el.dataset.sort;

		let container = el.closest('.list-sorts--sidebar');
		[...container.querySelectorAll('[data-sort]')].forEach(el => el.classList.remove('active'));
		el.classList.add('active');

		new Catalog().load();
	}
});
